import { transformAppDetails } from '../GetDetails';
import { ServerResponseType, CreateDriverResponseType } from './types';

export const transformCreateDriverResponse = (
  response: ServerResponseType
): CreateDriverResponseType => {
  return {
    id: response.identifier,
    appDetails: transformAppDetails(response),
  };
};
